<app-page-container>
  <div class="login-container-content prime-fg-color-3">

    <dx-form id="loginForm" class="prime-fg-color-3" #loginForm [formData]="loginFormData" [readOnly]="loading"
      (onContentReady)="onContentReady($event)">

      <dxi-item #code1 dataField="username" [label]="{ text: 'loginUsername' | translate }"
        [editorOptions]="{ tabIndex: 1, maxLength: 50, onEnterKey: onUsernameEnterKey }">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>

      <dxi-item #code1 dataField="password" [label]="{ text: 'password' | translate }"
        [editorOptions]="{ tabIndex: 2, mode: 'password', maxLength: 100,  onEnterKey: onSubmit  }">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>

      <dxi-item *ngIf="error && error.length" name="error">
        <div *dxTemplate>
          <span class="login-error-text color-error">{{error}}</span>
        </div>
      </dxi-item>

      <dxi-item *ngIf="emailVerified !== true" cssClass="datenschutz-container" dataField="confirm" [label]="{ visible: false }" [template]="'confirmTemplate'">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>

      <div *dxTemplate="let data of 'confirmTemplate'">
        <dx-check-box [(value)]="loginFormData.confirm"> </dx-check-box>
        <span class="datenschutz-link">
          {{ 'privacyAccept_1' | translate }}<a target="_blank" routerLink="/extern/privacy"> {{ 'privacyAccept_2' | translate }}</a
          >{{ 'privacyAccept_3' | translate }} *
        </span>
      </div>      

      <dxi-item name="submitButton">
        <div *dxTemplate class="loginSubmitButtonTemplateContainer">
          <dx-button *ngIf="emailVerified !== true" type="default" [height]="40" [width]="'100%'"
            (onClick)="onVerifySend()" [disabled]="loading || !loginFormData.confirm">
            <div *dxTemplate="let data of 'content'">
              <dx-load-indicator class='button-indicator' [visible]="loading">
              </dx-load-indicator>
              <span class='dx-button-text' [innerHtml]="'sendConfirmationMail' | translate"></span>
            </div>
          </dx-button>
          <dx-button id="loginSubmitButton" type="default" [height]="40" [width]="'100%'" (onClick)="onSubmit()"
            [disabled]="!emailVerified || loading">
            <div *dxTemplate="let data of 'content'">
              <dx-load-indicator class='button-indicator' [visible]="loading">
              </dx-load-indicator>
              <span class='dx-button-text' [innerHtml]="'login' | translate"></span>
            </div>
          </dx-button>

        </div>
      </dxi-item>
    </dx-form>
    <div class="register-content prime-fg-color-1">
      <div class="register-content-pw">
        <a class="register-content-pw-link" routerLink="/extern/register" queryParamsHandling="preserve"><i
            class="register-content-icon dx-icon-user"></i><span class="register-content-text"
            [innerHtml]="'register' | translate"></span></a>
      </div>
      <div class="register-content-pw">
        <a class="register-content-pw-link" routerLink="/extern/forget" queryParamsHandling="preserve"><i
            class="register-content-icon dx-icon-startswith"></i><span class="register-content-text"
            [innerHtml]="'forgotPassword' | translate"></span></a>
      </div>
    </div>
  </div>
</app-page-container>